// Import jQuery
import $ from "../../gulp/node_modules/jquery";
// export for others scripts to use
window.$ = window.jQuery = $;

// Require modules
// import browsetClassHelpers from './modules/browser-class-helpers.js';
import header from './modules/header.js';
import materialForm from './modules/material-form.js';
// import navScrollHighlight from './modules/nav-scroll-highlight.js';
import popin from './modules/popin.js';
// import scrollAnchor from './modules/scroll-anchor.js';
// import ssTooltip from './modules/tooltip';
import carousel3D from './modules/carousel3D';
import carouselMultipleItem from './modules/carouselMultipleItem';
import carouselBanner from './modules/carouselBanner';
import carouselCreations from './modules/carouselCreations';
import recipeSteps from './modules/recipeSteps';
import recipeSearch from './modules/recipeSearch';
import recipePreparation from './modules/recipePreparation';

function isTouchDevice(){
	try{
		document.createEvent("TouchEvent");
		return true;
	}catch(e){
		return false;
	}
}

$(function(){
	const assets_host_url = $('#rcp').attr('data-assets-host-url');

	$("html").removeClass("no-js");
	if(isTouchDevice()){
		$("html").addClass("js-touch");
	}

	if($(".Header__top-wrapper").length){
		$(".RCP-content").addClass("inNespresso");
	}

	// On renvoie un entier aléatoire entre une valeur min (incluse)
	// et une valeur max (exclue).
	function getRandomInt(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min)) + min;
	}
	function getXDifferentRandomInt(min, max, number){
		var tabResults = [];
		tabResults.push(getRandomInt(min, max));
		if(number > 0){
			while(tabResults.length < number){
				var newNum = getRandomInt(min, max);
				if(tabResults.indexOf(newNum) === -1){
					tabResults.push(newNum);
				}
			}
		}
		return tabResults;
	}

	// browsetClassHelpers.init();
	
	header.init();

	// if ($(".materialForm").length) {
	// 	materialForm.init();
	// }
	// if ($(".js-scroll-anchor").length) {
	// 	scrollAnchor.init();
	// }
	// if ($(".js-nav-link").length) {
	// 	navScrollHighlight.init();
	// }
	// if ($('.js-tooltip').length) {
	// 	ssTooltip.init();
	// }

	if ($(".js-RCPPopin").length) {
		popin.init();
	}

	if ($(".js-prep-container").length) {
		recipePreparation.init();
	}

	if ($('.js-carousel3D').length) {
		var numberOfSlide = 5
		,	$carousel3DSlide = $('.js-carousel3D').find(".swiper-slide")
		,	min = 0
		,	max = $carousel3DSlide.length;
		if($carousel3DSlide.length > numberOfSlide){
			$carousel3DSlide.addClass("js-toRemove");
			var indexesToKeep = getXDifferentRandomInt(min, max, numberOfSlide);
			for (var i = 0; i < indexesToKeep.length; i++) {
				$carousel3DSlide.eq(indexesToKeep[i]).removeClass("js-toRemove").removeClass("js-hide");
			}
			$('.js-carousel3D').find(".js-toRemove").removeClass("js-toRemove").removeClass("js-hide");
		}else{
			$('.js-carousel3D').find(".js-toRemove").removeClass("js-toRemove").removeClass("js-hide");
		}
		setTimeout(function(){//fix bug init 3d
			carousel3D.init('.js-carousel3D');
		},500)
	}

	const $carousel3D_json = $('.js-carousel3D-json');
	if ($carousel3D_json.length) {
		let alsoLikeJson_single_file_path;
		if (assets_host_url === 'empty') {
			alsoLikeJson_single_file_path = '../../../../../../app/uploads/also-like-json/'
		} else {
			alsoLikeJson_single_file_path = assets_host_url + 'also-like-json/'
		}
		alsoLikeJson_single_file_path = alsoLikeJson_single_file_path + $carousel3D_json.attr('data-post-id') + '.json';

		const carousel3D_template = $($('.js-carousel3D-template').html());
		const carousel3D_wrapper = $('.js-carousel3D-wrapper');

		// Retrieve slider datas from json
		$.getJSON(alsoLikeJson_single_file_path, function(recipesList) {
			let indexesToKeep = getXDifferentRandomInt(0, recipesList.length, 6);
			for (let i = 0; i < indexesToKeep.length; i++) {
				let index = indexesToKeep[i];
				let slideTemplate = carousel3D_template.clone();
				let recipeDatas = recipesList[index];

				slideTemplate.find('.js-recipeCardJson')
					.attr('data-categories', recipeDatas.data_attr.categories)
					.attr('data-personality_type', recipeDatas.data_attr.personality_type)
					.attr('data-recipeType', recipeDatas.data_attr.recipeType)
					.attr('data-capsuleType', recipeDatas.data_attr.capsuleType)
					.attr('data-cup_sizes', recipeDatas.data_attr.cup_sizes)
					.attr('data-difficulty', recipeDatas.data_attr.difficulty)
					.attr('data-allergens', recipeDatas.data_attr.allergens)
					.attr('data-allergensWithSubstitute', recipeDatas.data_attr.allergensWithSubstitute);

				slideTemplate.find('.js-recipeCardJson-small_image')
					.css('background-image', 'url('+recipeDatas.small_image+')')
				slideTemplate.find('.js-recipeCardJson-link')
					.attr('href', recipeDatas.link)
					.attr('data-href', recipeDatas.link)
					.attr('title', slideTemplate.find('.js-recipeCardJson-link').attr('title').replace('%recipe_title%', recipeDatas.title))
					.attr('onclick', slideTemplate.find('.js-recipeCardJson-link').attr('onclick').replace('%recipe_title%', recipeDatas.title))

				let recipe_category_template = slideTemplate.find('.js-recipeCardJson-recipe_category');
				recipeDatas.terms.recipe_category.forEach(function (category) {
					let clone_recipe_category = recipe_category_template.clone();
					clone_recipe_category.attr('href', category.link).text(category.name);
					slideTemplate.find('.js-recipeCardJson-recipe_category-list').append(clone_recipe_category);
				});
				recipe_category_template.remove();

				slideTemplate.find('.js-recipeCardJson-title')
					.text(recipeDatas.title)

				if (recipeDatas.show_personality_icon) {
					slideTemplate.find('.js-recipeCardJson-personality')
						.attr('href', recipeDatas.link)
						.find('.js-recipeCardJson-personality-text')
							.text(recipeDatas.personality_text)
					slideTemplate.find('.js-recipeCardJson-personality svg')
						.addClass('icon-'+recipeDatas.personality_icon)
					slideTemplate.find('.js-recipeCardJson-personality use')
						.attr('href', '#icon-'+recipeDatas.personality_icon)
				} else {
					slideTemplate.find('.js-recipeCardJson-personality').remove();
				}

				if (recipeDatas.post_type === 'food') {
					slideTemplate.find('.js-recipeCardJson-food')
						.attr('href', recipeDatas.see_all_food_link)
				} else {
					slideTemplate.find('.js-recipeCardJson-food').remove();
				}

				let range_template = slideTemplate.find('.js-recipeCardJson-range');
				recipeDatas.terms.range.forEach(function (category) {
					let clone_range = range_template.clone();
					clone_range.attr('href', category.search_link);
					clone_range.find('.js-recipeCardJson-range-name')
						.text(category.name);
					clone_range.find('.js-recipeCardJson-range-icon')
						.html(category.range_icon);

					range_template.before(clone_range);
				});
				range_template.remove();


				slideTemplate.find('.js-recipeCardJson-difficulty')
					.attr('href', recipeDatas.link)
					.find('.js-recipeCardJson-difficulty-name')
					.text(recipeDatas.difficulty_name)
				slideTemplate.find('.js-recipeCardJson-difficulty svg')
					.addClass('icon-'+recipeDatas.difficulty_icon)
				slideTemplate.find('.js-recipeCardJson-difficulty use')
					.attr('href', '#icon-'+recipeDatas.difficulty_icon)

				carousel3D_wrapper.append(slideTemplate);
			}

			setTimeout(function () {//fix bug init 3d
				carousel3D.init('.js-carousel3D-json');
			}, 500)
		});
	}

	if ($('.js-carouselMultipleItem').length) {
		carouselMultipleItem.init();
	}
	if ($('.js-carouselBanner').length) {
		var numberOfSlide = 4
		,	$carouselBannerSlide = $('.js-carouselBanner').find(".swiper-slide")
		,	min = 0
		,	max = $carouselBannerSlide.length;
		if($carouselBannerSlide.length > numberOfSlide ){
			var indexesToKeep = getXDifferentRandomInt(min, max, numberOfSlide);
			for (var i = 0; i < indexesToKeep.length; i++) {
				$carouselBannerSlide.eq(indexesToKeep[i]).removeClass("js-toRemove").removeClass("js-hide");
			}
			$('.js-carouselBanner').find(".js-toRemove").remove();
		}else{
			$('.js-carouselBanner').find(".js-toRemove").removeClass("js-toRemove").removeClass("js-hide");
		}
		carouselBanner.init();
	}
	if ($('.js-carouselCreations').length) {
		var $carouselCreations_slide = $('.js-carouselCreations').find(".js-carouselCreations-slide")
		if($carouselCreations_slide.length > 3){
			var indexesToKeep = getXDifferentRandomInt(0, $carouselCreations_slide.length, 3)
			for (var i = 0; i < indexesToKeep.length; i++) {
				$carouselCreations_slide.eq(indexesToKeep[i]).removeClass("js-toRemove").removeClass("js-hide");
			}
			$('.js-carouselCreations').find(".js-toRemove").remove();
		}else{
			$('.js-carouselCreations').find(".js-toRemove").removeClass("js-toRemove").removeClass("js-hide");
		}
		// triggered once popin barista is open, because swipper will handle baddly otherwise
		$(window).on("initCreationSlider",function(){
			carouselCreations.init();
		});
	}

	if ($('.js-tabContent').length) {
		$(".js-tabContent").each(function(){
			var $thisTab = $(this)
			,	$tabLink = $thisTab.find(".js-tabLink")
			,	$tabs = $thisTab.find(".js-tab");
			$tabLink.click(function(e){
				e.preventDefault();
				var $thisTabLink = $(this)
				,	$target = $($thisTabLink.attr("href"));
				$tabLink.removeClass("active");
				$thisTabLink.addClass("active");
				$tabs.removeClass("active");
				$target.addClass("active");

				/** Recipe Preparations :
				 *  Switching tabs may change the slider height so we must update it */
				if (recipePreparation.ui.$tabContent.length > 1) {
					recipePreparation.prepSlider.updateAutoHeight();
				}
			});
		});
	}
	if ($('.js-recipeGridShowMore').length) {
		$(".js-recipeGridShowMore").on("click", function(){
			var $this = $(this)
			,	$recipeGrid = $this.closest(".js-recipeGrid")
			,	$toShow = $recipeGrid.find(".js-recipeGrid__item.js-hide");
			for (var i = 0; i < 8; i++) {
				$toShow.eq(i).removeClass("js-hide");
			}
			if($recipeGrid.find(".js-recipeGrid__item.js-hide").length<1){
				$this.hide();
			}
		});
	}
	if($(".js-ingredient-noallergen").length){
		var $ingredient_allergen = $(".js-ingredient-allergen");
		var $ingredient_noallergen = $(".js-ingredient-noallergen");
		var search = window.location.search;
		if(search && search.indexOf("allergens") != -1){
			$ingredient_noallergen.removeClass("js-hide");
			$ingredient_allergen.addClass("js-hide");
		}
	}

	if($(".js-recipeSteps").length){
		$(".js-recipeSteps").each(function(){
			var recipeStepInstance = new recipeSteps($(this));
			recipeStepInstance.init();
		});
		var $recipeSteps_allergen = $(".js-recipeSteps-allergen");
		var $recipeSteps_no_allergen = $(".js-recipeSteps-no-allergen");
		if($recipeSteps_no_allergen){
			var search = window.location.search;
			if(search && search.indexOf("allergens") != -1){
				$recipeSteps_no_allergen.removeClass("js-hide");
				$recipeSteps_allergen.addClass("js-hide");
			}
		}
	}

	if($(".js-baristaAdvicePush").length){
		var $baristaAdvicePush = $(".js-baristaAdvicePush")
		,	chooseRandom = getRandomInt(0, $baristaAdvicePush.length);
		if($(".js-barista-single").eq(0).attr("data-barista-advice-single-ID") == $baristaAdvicePush.eq(chooseRandom).attr("data-barista-advice-single-ID")){
			chooseRandom = getRandomInt(0, $baristaAdvicePush.length);
		}
		$baristaAdvicePush.addClass("js-hide");
		$baristaAdvicePush.eq(chooseRandom).removeClass("js-hide");
	}
	
	if(!window.napi){
		console.log("error api nespresso");
		$(".add-to-bag").append($('<button type="button" title="Ajouter au panier" class="fakeAPI__Btn"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></div>'));
	}
	
	let napi = window.napi || {
		catalog:function(){
			return {
				getProduct: function(){
					return new Promise(function(resolve, reject) {
						setTimeout(function() {
							console.log('fakeAPI');
							resolve({"modelType":"Capsule","id":"erp.fr.b2c/prod/7702.20","legacyId":"7702.20","internationalId":"7702.20","name":"Ristretto Decaffeinato","urlFriendlyName":"ristretto-decaffeinato-capsule-cafe","internationalName":"Ristretto Decaffeinato New","headline":"Intensément grillé et une pointe fruitée","description":"<!-- content start here -->\n<div id=\"pdp_cof_ristretto_decaff\" class=\"dp_fit_vol\" data-lang=\"fr\">\n\t<div class=\"dp_fit_vol_wrap\">\n\t\t<section class=\"dp_fit_vol_content dp_fit_vol_prod\">\n\t\t\t<div class=\"dp_fit_vol_row\">\n\t\t\t\t<div class=\"dp_fit_vol_left\">\n\t\t\t\t\t<h2 class=\"dp_fit_vol_sec_title\">INTENS&Eacute;MENT GRILL&Eacute; ET UNE POINTE FRUIT&Eacute;E</h2>\n\t\t\t\t\t<p class=\"dp_fit_vol_prod_desc\">\n\t\t\t\t\t\tMariage d&rsquo;Arabicas d&rsquo;Am&eacute;rique latine et d&rsquo;Afrique de l&rsquo;Est, Ristretto Decaffeinato poss&egrave;de les m&ecirc;mes subtiles notes fruit&eacute;es, ainsi que les m&ecirc;mes notes intens&eacute;ment torr&eacute;fi&eacute;es et chocolat&eacute;es que le Grand Cru embl&eacute;matique Ristretto.\n\t\t\t\t\t\t<br class=\"dp_fit_vol_mob_show\">\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class=\"dp_fit_vol_prod_price\">Prix aux 100g : 7,09&euro;</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"dp_fit_vol_right\">\n\t\t\t\t\t<div class=\"dp_fit_vol_logo_holder\">\n\t\t\t\t\t\t<div class=\"dp_fit_vol_logo_left\">\n\t\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/dp_aaa_logo.png\" alt=\"\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"dp_fit_vol_logo_right\">\n\t\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/dp_rainforest_logo.png\" alt=\"\">\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class=\"dp_fit_vol_logo_desc\">Le Programme Nespresso AAA pour une Qualit&eacute; Durable a &eacute;t&eacute; d&eacute;velopp&eacute; avec Rainforest Alliance. Aujourd&rsquo;hui, +80% du caf&eacute; Nespresso est issu de fermes certifi&eacute;es AAA, et +40% est issu de fermes certifi&eacute;es Rainforest Alliance.</p>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class=\"dp_fit_vol_content dp_fit_vol_prod_info\">\n\t\t\t<div class=\"dp_fit_vol_row\">\n\t\t\t\t<div class=\"dp_fit_vol_left\">\n\t\t\t\t\t<div class=\"dp_fit_vol_info_box\">\n\t\t\t\t\t<div class=\"dp_fit_vol_capsule\">\n\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/Ristretto-Decaf-pdp-enh.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"dp_fit_vol_cap_desc\">\n\t\t\t\t\t\t<div class=\"dp_fit_vol_cap_left\">\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<h3><span>Amertume</span></h3>\n\t\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_indicator\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_ind_active\">&#9632; &#9632; &#9632; &#9632;</span> <span> &#9632;</span>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<h3><span>acidit&eacute;</span></h3>\n\t\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_indicator\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_ind_active\">&#9632; &#9632; &#9632;</span> <span>&#9632; &#9632;</span>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"dp_fit_vol_cap_right\">\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<h3><span>corps</span></h3>\n\t\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_indicator\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_ind_active\">&#9632; &#9632; &#9632; &#9632;</span> <span> &#9632;</span>\t\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<h3><span>torr&eacute;faction</span></h3>\n\t\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_indicator\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_ind_active\">&#9632; &#9632; &#9632; &#9632;</span> <span> &#9632;</span>\t\t\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"dp_fit_vol_cap_intens\">\n\t\t\t\t\t\t<p>intensit&eacute; <span>10</span></p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"dp_fit_vol_right dp_fit_vol_icon_holder\">\n\t\t\t\t\t<div class=\"dp_fit_vol_cap_desc_row\">\n\t\t\t\t\t\t<span class=\"dp_fit_fow_cap_desc_text\">Intensit&eacute;</span>\n\t\t\t\t\t\t<span class=\"dp_fit_fow_cap_desc_indicator\">10 <span class=\"dp_fit_vol_ind_active\">&#9632; &#9632; &#9632; &#9632; &#9632; &#9632; &#9632; &#9632; &#9632; &#9632;</span> <span class=\"dp_fit_vol_ind_inactive\"> &#9633; &#9633; </span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"dp_fit_vol_cap_desc_row dp_fit_vol_cap_clr_side_padd\">\n\t\t\t\t\t\t<span class=\"dp_fit_fow_cap_desc_text\">Tailles de tasses</span>\n\t\t\t\t\t\t<ul class=\"dp_fit_vol_list_color dp_fit_vol_four_cups\">\n\t\t\t\t\t\t\t<li class=\"dp_fit_vol_list_first dp_fit_vol_cap_icon_text_active\">\n\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_icon\">\n\t\t\t\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/dp_ristretto_cup.png\" alt=\"\">\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_icon_text\">Ristretto<br>25 ml</span>\n\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t<li class=\"dp_fit_vol_list_second dp_fit_vol_cap_icon_text_active\">\n\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_icon\">\n\t\t\t\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/dp_espresso_cup.png\" alt=\"\">\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_icon_text\">Espresso<br>40 ml</span>\n\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t<li class=\"dp_fit_vol_list_third\">\n\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_icon\">\n\t\t\t\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/dp_lungo_cup_unactive.png\" alt=\"\">\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_icon_text\">Lungo<br>110 ml</span>\n\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t<li class=\"dp_fit_vol_list_fourth\">\n\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_icon\">\n\t\t\t\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/dp_capucchino_cup_unactive.png\" alt=\"\">\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span class=\"dp_fit_vol_cap_icon_text\">Cappuccino<br>Recette Lait</span>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"dp_fit_vol_cap_desc_row\">\n\t\t\t\t\t\t<span class=\"dp_fit_fow_cap_desc_text\">Famille aromatique</span>\n\t\t\t\t\t\t<span class=\"dp_fit_fow_cap_desc_right_text\">Les intenses</span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"dp_fit_vol_cap_desc_row\">\n\t\t\t\t\t\t<span class=\"dp_fit_fow_cap_desc_text\">Notes aromatiques</span>\n\t\t\t\t\t\t<span class=\"dp_fit_fow_cap_desc_right_text\">Intens&eacute;ment grill&eacute;e/ <br>Pointe fruit&eacute;e</span>\n\t\t\t\t\t</div>\t\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\n\t\t<section class=\"dp_fit_vol_content dp_fit_vol_map_holder\">\n\t\t\t<div class=\"dp_fit_vol_row dp_fit_vol_first_row\">\n\t\t\t\t<div class=\"dp_fit_vol_left\">\n\t\t\t\t\t<h3>ORIGINE</h3>\n\t\t\t\t\t<p class=\"dp_fit_vol_prod_desc\">Compos&eacute; des meilleurs Arabicas d&rsquo;Am&eacute;rique du Sud provenant de pays comme la Colombie et le Br&eacute;sil, Ristretto Decaffeinato contient aussi les grands Arabicas d&rsquo;Afrique de l&rsquo;Est, finement acidul&eacute;s et une touche de Robusta pour la nervosit&eacute;.</p>\n\t\t\t\t</div>\t\n\t\t\t\t<div class=\"dp_fit_vol_right\">\n\t\t\t\t\t<div class=\"dp_fit_vol_w_map brasil columbia\">\n\t\t\t\t\t\t<span class=\"brasil\">br&eacute;sil</span>\n\t\t\t\t\t\t<span class=\"columbia\">Colombie</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t</div>\n\n\n\t\t\t<div class=\"dp_fit_vol_row  dp_fit_vol_second_row\">\n\t\t\t\t<div class=\"dp_fit_vol_left\">\n\t\t\t\t\t<div class=\"dp_fit_vol_row_box\">\n\t\t\t\t\t\t<h3>TORR&Eacute;FACTION</h3>\n\t\t\t\t\t\t<p class=\"dp_fit_vol_prod_desc\">Les grains sont torr&eacute;fi&eacute;s lentement et s&eacute;par&eacute;ment pour obtenir un bouquet original compos&eacute; de notes acidul&eacute;es, fruit&eacute;es et grill&eacute;es. Sa texture finement moulue cr&eacute;e un caf&eacute; &agrave; l&rsquo;italienne : intense, avec une richesse de saveur et une pl&eacute;nitude de corps.</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"dp_fit_vol_row_box\">\n\t\t\t\t\t\t<h3>PROFIL AROMATIQUE</h3>\n\t\t\t\t\t\t<p class=\"dp_fit_vol_prod_desc\">Des notes torr&eacute;fi&eacute;es fortes adoucies par des notes de chocolat. Un contraste subtil entre force et amertume, des notes acidul&eacute;es et fruit&eacute;es.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"dp_fit_vol_right\">\n\t\t\t\t\t<h3> Amateur de Ristretto Decaffeinato ?</h3>\n\t\t\t\t\t<p><span>Nespresso</span> vous invite &agrave; <br class=\"dp_fit_hide_on_mob\">d&eacute;couvrir Ristretto.</p>\n\t\t\t\t\t<div class=\"dp_fit_vol_volluto\">\n\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/Ristretto-pdp-enh.jpg\" alt=\"\">\n\t\t\t\t\t\t<a href=\"/fr/fr/order/capsules/original/ristretto-capsule-cafe\" title=\"D&eacute;couvrez\">D&eacute;couvrez</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\t\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class=\"dp_fit_vol_content dp_fit_vol_decaf\">\n\t\t\t<h3>la d&eacute;caf&eacute;ination chez nespresso</h3>\n\t\t\t<p>Un proc&eacute;d&eacute; qui respecte l&rsquo;environnement et votre sant&eacute;.</p>\n\t\t\t<div class=\"dp_fit_vol_decaf_read_more\">\n\t\t\t\t<a href=\"/fr/fr/cafe-deca#decafeination\" title=\"En savoir plus\">En savoir plus</a>\n\t\t\t</div>\n\t\t</section>\n\n\t\t<section class=\"dp_fit_vol_content dp_fit_vol_assort\">\n\t\t\t<div class=\"dp_fit_vol_row\">\n\t\t\t\t<div class=\"dp_fit_vol_left\">\n\t\t\t\t\t<div class=\"dp_fit_vol_colection\">\n\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/dp_decaffeinato_caps_colection.jpg\" alt=\"\" class=\"dp_fit_hide_on_mob\">\n\t\t\t\t\t\t<img src=\"https://www.nespresso.com/shared_res/mos/free_html/fr/mosaic-responsive-fr/images/coffee/dp_decaffeinato_caps_colection_m.jpg\" alt=\"\" class=\"dp_fit_show_on_mob\">\n\t\t\t\t\t</div>\t\n\t\t\t\t</div>\n\t\t\t\t<div class=\"dp_fit_vol_right\">\n\t\t\t\t\t<div class=\"dp_fit_vol_colection_text\">\n\t\t\t\t\t\t<h3 class=\"decaffeinato_mobile\">D&eacute;COUVREZ LA&nbsp;GAMME DE CAF&Eacute;<br> DECAFFEINATO</h3>\n\t\t\t\t\t\t<a href=\"/fr/fr/cafe-deca\" title=\"D&eacute;couvrez\">D&eacute;couvrez</a>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t\t<p class=\"dp_fit_vol_prod_desc\">Les capsules de caf&eacute; sont vendues par &eacute;tuis de 10.<br>Pour commander, votre panier doit contenir au moins 5 &eacute;tuis au total &agrave; s&eacute;lectionner parmi toute la gamme de caf&eacute;s.</p>\n\t\t</section>\n\t</div>\n\t\t\n</div>\n<!-- content end here -->","rootCategory":"capsules_original","category":"Others","supercategories":["bmVzY2x1YjIuZnIuYjJjL2NhdC9vcmlnaW5hbA==","bmVzY2x1YjIuZnIuYjJjL2NhdC9wcm9kdWN0cy1jYXBzdWxl","bmVzY2x1YjIuZnIuYjJjL2NhdC9jYXBzdWxlLWN1cFNpemUtcmlzdHJldHRv","bmVzY2x1YjIuZnIuYjJjL2NhdC9jYXBzdWxlLWN1cFNpemUtZXNwcmVzc28=","bmVzY2x1YjIuZnIuYjJjL2NhdC9jYXBzdWxlLWFyb21hdGljLWludGVuc2U=","bmVzY2x1YjIuZnIuYjJjL2NhdC9yZWNpcGUtY2Fwc3VsZS1hcm9tYXRpYy1oaW50T2ZGcnVpdHk=","bmVzY2x1YjIuZnIuYjJjL2NhdC9yZWNpcGUtY2Fwc3VsZS1hcm9tYXRpYy12ZXJ5Um9hc3RlZA=="],"images":{"modelType":"CapsuleImages","icon":"https://www.nespresso.com/ecom/medias/sys_master/public/12231472316446.png","main":"https://www.nespresso.com/ecom/medias/sys_master/public/10433309048862/Ristrettodecaf-PDP-.jpg","push":"https://www.nespresso.com/ecom/medias/sys_master/public/10252250677278/C-0262-mosaic-CrossPush-214x187.jpg","carousel":"https://www.nespresso.com/ecom/medias/sys_master/public/10320348774430/RECIPE-RISTRETTO-DECAFFEINATO-Carousel.png","foreground":"https://www.nespresso.com/ecom/medias/sys_master/public/10320348839966/RECIPE-RISTRETTO-DECAFFEINATO-Fore.png","cardBackground":"https://www.nespresso.com/ecom/medias/sys_master/public/10320346710046/RECIPE-RISTRETTO-DECAFFEINATO-Card-Back.png","detailsPageBackground":"https://www.nespresso.com/ecom/medias/sys_master/public/10320346939422/RECIPE-RISTRETTO-DECAFFEINATO-Page-Back.png"},"mobileImages":{"modelType":"Images","icon":"/mobile/media/get/8828759081010/{deviceProfile}/1551781266758","main":"/mobile/media/get/8828759048242/{deviceProfile}/1522056805025"},"responsiveImages":{"standard":"https://www.nespresso.com/ecom/medias/sys_master/public/12202991091742/C-0262-DECAFFEINATO-RISTRETTO-Capsules-2000x2000.png"},"ingredients":[{"type":"DESCRIPTION","text":"10 capsules de café décaféiné torréfié et moulu pour système Nespresso."},{"type":"TITLE","text":"INGRÉDIENTS & ALLERGÈNES"},{"type":"DESCRIPTION","text":"Café décaféiné torréfié et moulu. Conditionné sous atmosphère protectrice."},{"type":"TITLE","text":"POIDS NET (POUR 10 CAPSULES)"},{"type":"DESCRIPTION","text":"55g - 1.94oz"},{"type":"TITLE","text":"FABRIQUÉ EN SUISSE"}],"pdpURLs":{"desktop":"https://www.nespresso.com/fr/fr/order/capsules/original/ristretto-decaffeinato-capsule-cafe","mobile":"https://www.nespresso.com/mobile/fr/fr/produits/Capsule/Ristretto-Decaffeinato/p/ristretto-decaffeinato-capsule-cafe"},"unitQuantity":1,"salesMultiple":10,"quantities":[0,10,20,30,40,50,60,70,80,90,100,110,120,130,140,150,160,170,180,190,200,210,220,230,240,250,260,270,280,290,300,310,320,330,340,350,360,370,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620,630,640,650,660,670,680,690,700,710,720,730,740,750,760,770,780,790,800,810,820,830,840,850,860,870,880,890,900,910,920,930,940,950,960,970,980,990,1000,1100,1200,1300,1400,1500,1600,1700,1800,1900,2000,2100,2200,2300,2400,2500,2600,2700,2800,2900,3000,3100,3200,3300,3400,3500,3600,3700,3800,3900,4000,4100,4200,4300,4400,4500,4600,4700,4800,4900,5000],"maxOrderQuantity":5000,"technologies":["nesclub2.fr.b2c/machineTechno/original"],"comingSoon":false,"productSelections":["10","14","60","61","62","63","64","65","3332","3485","3490","3775","3830","3845","3869","3917","3930","3941"],"type":"capsule","slides":[{"url":"https://www.nespresso.com/ecom/medias/sys_master/public/10392427986974/C-0262-PDP-Background.jpg"}],"displayEcoTax":false,"bundled":false,"capsuleProperties":{"intensity":10},"capsuleProductAromatics":["NOTES DE FRUIT","INTENSÉMENT GRILLÉ"],"inStock":false,"currency":"EUR","price":0.6,"unitPrice":0.6});
						}, 300)
					});
				}
			};
		},
		
	};
	if($(".js-RCP_napi_ingredient").length){
		var theStickyOne = false;
		$(".js-RCP_napi_ingredient").each(function(){
			var $this = $(this)
			,	idNAPI = $this.attr("data-idNAPI");
			napi.catalog().getProduct(idNAPI).then(function(value){
				$this.find(".js-RCP_napi_ingredient-img").attr("src",value.images.icon);
				$this.find(".js-RCP_napi_ingredient-price").text(parseFloat(value.price).toFixed(2)+"€");
				if($this.hasClass("js-recipeStickyProduct") && !theStickyOne){
					theStickyOne = true;
					var $recipeStickyProduct = $(".js-recipeStickyProduct");
					$recipeStickyProduct.removeClass("js-hide")				
					$recipeStickyProduct.find(".js-recipeStickyProduct-img").attr("src", value.images.icon);
					$recipeStickyProduct.find(".js-recipeStickyProduct-name").text(value.name);
					$recipeStickyProduct.find(".js-recipeStickyProduct-headline").text(value.headline);
					$recipeStickyProduct.find(".js-recipeStickyProduct-price").text(parseFloat(value.price).toFixed(2)+"€");

					$recipeStickyProduct.find(".js-RCPintensity__steps").text(parseFloat(value.price).toFixed(2)+"€");
					var $recipeStickyProduct__intensity = $recipeStickyProduct.find(".js-RCPintensity__step");
					if(value.capsuleProperties && value.capsuleProperties.intensity ){
						var intensity = value.capsuleProperties.intensity;
						for (var i = 0; i < intensity; i++) {
							$recipeStickyProduct__intensity.eq(i).addClass("active");
						}
						$recipeStickyProduct__intensity.eq(intensity-1).after($("<span class='RCPintensity__step-intensity'>"+intensity+"</span>"))
					}else{
						$recipeStickyProduct__intensity.hide();
					}

				}
			});
		});
	}
	if($(".js-complementaryProduct").length){
		$(".js-complementaryProduct").each(function(){
			var $this = $(this)
			,	idNAPI = $this.attr("data-idNAPI");
			napi.catalog().getProduct(idNAPI).then(function(value){
				// console.log(value);
				$this.find(".js-complementaryProduct__price").text(parseFloat(value.price).toFixed(2)+"€");
				$this.find(".js-complementaryProduct__title").text(value.name);
				$this.find(".js-complementaryProduct__visuel img").attr("src",value.images.icon);
				$(".js-complementaryProducts").removeClass("js-hide");
				$this.removeClass("js-hide");
			});
		});
	}

	if($(".js-getInstagram").length){
		// basic display
		// https://developers.facebook.com/docs/instagram-basic-display-api/overview/#user-token-generator
		var $instagramBlock = $(".js-getInstagram")
		,	insta_accessToken = $instagramBlock.attr("data-accessToken")
		,	instagram_ID = $instagramBlock.attr("data-instagram_ID")
		,	old_token = $instagramBlock.attr("data-old_token")
		,	nbinstaPost = 4
		$.ajax({
            method: "POST",
            url: $instagramBlock.attr("data-get-token"),
            data: {
                'action': 'get_insta_token',
                'instagram_ID': instagram_ID,
                'old_token': old_token
            }
        })
        .done(function(rep) {
			$.get(
				"https://graph.instagram.com/"+instagram_ID+"/media?fields=media_url,permalink,thumbnail_url&count="+nbinstaPost+"&access_token="+rep,
				function(response){}
			).done(function(response) {
				var data = response["data"];
				for (var i = 0; i < nbinstaPost; i++) {
					var $imgInstaTPL = $(".js-imgInstaTPL").clone();
						let media_url = data[i]["media_url"];
						if(data[i]["thumbnail_url"]){
							media_url = data[i]["thumbnail_url"];
						}
						$imgInstaTPL.find(".js-imgInsta")
							.css("background-image", "url("+media_url+")")
						.attr("href",data[i]["permalink"]);
					$imgInstaTPL.removeClass("js-hide").removeClass("js-imgInstaTPL").appendTo($(".js-instaflux"));
				}
				$instagramBlock.removeClass("js-hide");
			})
			.fail(function(response) {
				console.log(response);
			})
			.always(function(response) {
			});
        });
	}

	if($(".js-recipe-search-list").length){
		recipeSearch.init();
	}

	var $rcpBannerLoader = $(".js-rcpBanner-rcpLoader")
	if($rcpBannerLoader.length){
		setTimeout(function(){
			$rcpBannerLoader.css({"z-index":0});
		},1000)
	}
});
